import router from '../router'

//import Swal from 'sweetalert2';
import Swal from 'sweetalert2/dist/sweetalert2.js'
//import IndexModal from '../components/modals/IndexModal'


// Funcion para CARGAR SPINER
export function showSpinner() {
  Swal.fire({
    title: 'Cargando...',
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
}

// Funcion para CERRAR SPINER
export function closeSpinner() {
  Swal.close();
}

// Función para mostrar una alerta de ÉXITO
export function showSuccessAlert(message) {
  Swal.fire({
    icon: 'success',
    title: 'Éxito',
    text: message,
    showConfirmButton: true,
    confirmButtonText: 'Ok',
    allowOutsideClick: false,
    allowEscapeKey: false 
  }).then((result) => {
    if (result.isConfirmed) {
      router.go();
    }
  })
}
// Función para mostrar una alerta de ÉXITO y llevar a la vista publica
export function showSuccessAlertForm(message) {
  Swal.fire({
    icon: 'success',
    title: 'Éxito',
    text: message,
    showConfirmButton: true,
    confirmButtonText: 'Ok',
    allowOutsideClick: false,
    allowEscapeKey: false 
  }).then((result) => {
    if (result.isConfirmed) {
      router.push({ name: 'FormPublicFinalized' });
    }
  })
}

// Función para mostrar una alerta de INFORMACION
export function showInfoAlert(message) {
  Swal.fire({
    icon: 'info',
    title: 'Información',
    text: message,
  });
}

// Función para mostrar una alerta de ERROR
export function showErrorAlert(message) {
  Swal.fire({
    icon: 'error',
    title: 'Error 500',
    text: message,
  });
}

// Función para procesar varios errores en una lista y mostrarlos en una alerta
export function processErrors(errorText) {
  Swal.fire({
    icon: 'info',
    title: 'Información',
    html: errorText,
  });
}
// Función para procesar Errores en General
export function globalErrors(message,errorStatus) {
  Swal.fire({
    icon: 'error',
    title: `Error ${errorStatus}`,
    text: message,
  });
}

// Función para mostrar una alerta de INFORMACION
export function showInfoAlertArmas() {
  Swal.fire({
    icon: 'info',
    title: 'Información',
    text: 'Sin Resultados',
  });
}

// DATOS DE FRONT:
// Función para mostrar una alerta de INFORMACION
export function globalInfoData(message, dato, okButtonText = 'OK') {
  Swal.fire({
    icon: 'success',
    title: dato,
    text: message,
    showConfirmButton: true,
    confirmButtonText: okButtonText,
  }).then((result) => {
    if (result.isConfirmed) { 
      // Aquí cerramos el modal
      //const modal = new bootstrap.Modal(document.getElementById('indexModal'));
      $('#indexModalPersonalAsignacion').modal('hide');
      $('#indexModalPersonalUsuario').modal('hide');
    }
  });
}
